import React, { useContext, useState } from 'react';

import { ThemeProvider } from '@mui/material';
import { Theme } from '@mui/system';
import { AquaSpecies } from 'types/shared/aqua-species.type';
import { salmonTheme, shrimpTheme } from 'theme';

type ThemeOptions = {
  [key: string]: Theme;
};

const themes: ThemeOptions = {
  salmon: salmonTheme,
  shrimp: shrimpTheme,
};

type State = {
  aquaSpecies: string;
  changeTheme(themeType: AquaSpecies): void;
};

type ThemeContextProviderProps = {
  children: React.ReactNode;
};

const ThemeContext = React.createContext<State | undefined>(undefined);

const SetInitialThemeType = () => {
  let initTheme: string = localStorage.getItem('themeType') || 'salmon';

  return initTheme;
};

const ThemeContextProvider: React.FC<ThemeContextProviderProps> = ({ children }) => {
  const [themeType, setThemeType] = useState(SetInitialThemeType());
  localStorage.setItem('themeType', themeType);

  const changeThemeType = (theme: AquaSpecies): void => {
    localStorage.setItem('themeType', theme);
    setThemeType(theme);
  };

  const getTheme = (themeType: string) => themes[themeType] ?? salmonTheme;

  return (
    <ThemeContext.Provider value={{ aquaSpecies: themeType, changeTheme: changeThemeType }}>
      <ThemeProvider theme={getTheme(themeType)}>{children}</ThemeProvider>
    </ThemeContext.Provider>
  );
};

function useThemeState() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useThemeState must be used within a ThemeContextProvider');
  }
  return context;
}

export { ThemeContextProvider, useThemeState };
